import { Skeleton } from "../ui/skeleton";

export function Loading() {
  return (
    <div className="grid grid-cols-4 gap-4">
      <Skeleton className="rounded-md min-h-[350px] p-4 border border-[#e2e8f0]" />
      <Skeleton className="rounded-md min-h-[350px] p-4 border border-[#e2e8f0]" />
      <Skeleton className="rounded-md min-h-[350px] p-4 border border-[#e2e8f0]" />
      <Skeleton className="rounded-md min-h-[350px] p-4 border border-[#e2e8f0]" />
    </div>
  )
}